import styles from './styles.module.scss';

export default function MainButton({onClick, children, type}) {
	return (
		<button	className={styles[type]} onClick={onClick} >
			{children}
		</button>
	)
}
